import * as React from 'react';
import { useLocation } from "react-router-dom";

type Props = {
  onNavigate: () => any,
};
type State = {};

export default function SidebarHideOnNavigation(props: Props): JSX.Element {
  const location = useLocation();
  React.useEffect(props.onNavigate, [location]);
  return null;
}
